/* eslint-disable react/prop-types */
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import React, { useContext } from "react";
import * as Sentry from "@sentry/react";
import Button from "../../../../components/common/Button";
import { ToastAlertContext } from "../../../../config/providers/ToastAlert";
import { AlertStatus } from "../../../../contants";
import Appointment from "../../../../services/api/appointment";

function DeleteStructureModal({ open, onClose, structureId, refreshList }) {
  const alert = useContext(ToastAlertContext);

  const onAccept = async () => {
    try {
      await Appointment.deleteStructure(structureId);
      alert.show("Successfully Deleted", AlertStatus.SUCCESS);
      refreshList();
    } catch (error) {
      if (error.status === 400) {
        alert.show("Structure contains child structures", AlertStatus.ERROR);
      } else {
        alert.show(error.message, AlertStatus.ERROR);
      }
      Sentry.captureException(error);
    } finally {
      onClose();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Are you sure?</DialogTitle>
      <DialogActions>
        <Button onClick={onAccept} label="Yes" />
        <Button variant="outlined" onClick={onClose} label="No" />
      </DialogActions>
    </Dialog>
  );
}

export default DeleteStructureModal;
